var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFShadeGuideInside01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "422px",
    height: "510px",
    viewBox: "0 0 422 510",
    enableBackground: "new 0 0 422 510",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 128.4,
    opacity: 0.8,
    fill: "#DCDCDC",
    width: 233.8,
    height: 277.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.5,
    x1: 126.5,
    y1: 463.1,
    x2: 126.5,
    y2: 461.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.5,
    strokeDasharray: "3.9927,3.9927",
    x1: 126.5,
    y1: 457.1,
    x2: 126.5,
    y2: 139.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.5,
    x1: 126.5,
    y1: 137.7,
    x2: 126.5,
    y2: 135.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "131,461.8 126.5,469.6 122.1,461.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "131,137 126.5,129.2 122.1,137  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.5,
    x1: 211,
    y1: 463.1,
    x2: 211,
    y2: 461.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.5,
    strokeDasharray: "3.9927,3.9927",
    x1: 211,
    y1: 457.1,
    x2: 211,
    y2: 139.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.5,
    x1: 211,
    y1: 137.7,
    x2: 211,
    y2: 135.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "215.5,461.8 211,469.6 206.5,461.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "215.5,137 211,129.2 206.5,137  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.5,
    x1: 294.9,
    y1: 463.1,
    x2: 294.9,
    y2: 461.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.5,
    strokeDasharray: "3.9927,3.9927",
    x1: 294.9,
    y1: 457.1,
    x2: 294.9,
    y2: 139.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.5,
    x1: 294.9,
    y1: 137.7,
    x2: 294.9,
    y2: 135.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "299.4,461.8 294.9,469.6 290.4,461.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "299.4,137 294.9,129.2 290.4,137  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.5,
    x1: 100.4,
    y1: 311.1,
    x2: 321.6,
    y2: 311.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "101.8,315.6 94,311.1 101.8,306.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "320.2,315.6 328,311.1 320.2,306.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.5,
    x1: 100.4,
    y1: 160.5,
    x2: 321.6,
    y2: 160.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "101.8,165 94,160.5 101.8,156  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "320.2,165 328,160.5 320.2,156  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.5,
    x1: 100.4,
    y1: 439.5,
    x2: 321.6,
    y2: 439.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "101.8,444 94,439.5 101.8,435  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "320.2,444 328,439.5 320.2,435  "
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.9,
    y: 104.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 2.9998,
    strokeMiterlimit: 10,
    width: 280.1,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 127.6,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 2.9998,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFShadeGuideInside01);
export default __webpack_public_path__ + "static/media/FShadeGuide-inside-01.58bc3c69b32dc475c0bdaa74a11f931e.svg";
export { ForwardRef as ReactComponent };